import { addMonths, addWeeks, addYears } from 'date-fns'
import { Frequency } from '@omnea-app/packages/universal/form/elements/pricing'
import { PaymentIntervalEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { assertNever } from '@omnea-app/packages/universal/type-guards/assertNever'

export const addIntervals = (frequency: Frequency, start: Date, n: number): Date => {
  switch (frequency) {
    case PaymentIntervalEnum.ONE_OFF:
      return start
    case PaymentIntervalEnum.WEEK:
      return addWeeks(start, n)
    case PaymentIntervalEnum.MONTH:
      return addMonths(start, n)
    case PaymentIntervalEnum.QUARTER:
      return addMonths(start, n * 3)
    case PaymentIntervalEnum.EVERY_SIX_MONTHS:
      return addMonths(start, n * 6)
    case PaymentIntervalEnum.YEAR:
      return addYears(start, n)
    case PaymentIntervalEnum.EVERY_TWO_YEARS:
      return addYears(start, n * 2)
    default:
      assertNever(frequency)
      return start
  }
}
